import { OrderStatus, OrderType } from "../../../payment/order.mjs";
import { PaymentProvider } from "../../../payment/provider.mjs";
import { currencySchema } from "../../../payment/shared.mjs";
import { z } from "zod";
//#region src/api/orpc/order/schemas.ts
const bigintIdSchema = z.string().regex(/^\d+$/);
const orderSchema = z.object({
	id: bigintIdSchema,
	userId: bigintIdSchema,
	itemId: z.string(),
	type: z.enum(OrderType),
	provider: z.enum(PaymentProvider).nullable(),
	externalId: z.string().nullable(),
	status: z.enum(OrderStatus),
	amount: z.int(),
	currency: currencySchema,
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
});
//#endregion
export { orderSchema };
